import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users',
  title: 'Usuários',
  endpoint: '/app/person',
}
